// extracted by mini-css-extract-plugin
module.exports = {"header":"style-module__header___1D9Ro","body":"style-module__body___Av-bp"};